import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { AccountantPouchListedAdminDto } from '@/backend/market'
import { AccountantPouchMiniEntity } from '../../domain/entities/AccountantPouchMiniEntity'

export class AccountantPouchMiniModel extends AccountantPouchMiniEntity {
  constructor(dataDto: AccountantPouchListedAdminDto) {
    super()
    mapEntityProperties<AccountantPouchMiniModel>(this, dataDto)
  }
}
